import { createContext } from 'react'

const ClientContext = createContext({
    contract: {},
    setContract: () => {}
})

export default ClientContext
